import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    detailSectionContainer: { paddingTop: '1.2rem' },
    detailSection: {
        width: '32%',
        minWidth: 'fit-content' as 'fit-content'
    },
    mainTabContainer: { paddingBottom: '20px' },
    userTabsContainer: {
        height: '15px',
        background: '#F0F0F0',
        padding: '5px 0'
    },
    indicator: {
        height: '5px',
        background: '#4499D9',
        top: '0'
    },
    transactionAmount: { fontSize: '2.2rem' },
    headerAmountDetailsMain: { justifyContent: 'space-between' },
    headerDetailsContainer: {
        width: 'auto' as 'auto',
        paddingLeft: '2rem',
        justifyContent: 'center'
    },
    headerSmallDetail: {
        width: 'auto' as 'auto',
        paddingRight: '2rem',
        paddingTop: '0.5rem'
    },
    headerLabel: {
        width: 'max-content' as 'max-content',
        fontSize: '1.25rem',
        lineHeight: '1.2rem',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333',
        paddingRight: '.5rem'
    },
    headerAttribute: {
        fontSize: '.9rem',
        lineHeight: '1.5rem',
        fontWeight: 'bold' as 'bold',
        textTransform: 'uppercase' as 'uppercase'
    },
    headerAttributeNoCaps: { textTransform: 'none' as 'none' },
    '@media (max-width: 1360px)': {
        detailSection: {
            width: '100%',
            margin: '0 55px 10px 27px'
        }
    }
}));